/** Format 24h time string "HH:MM" (or Date) to 12-hour "h:mm AM/PM" */
export function fmt12(input) {
  if (!input) return "";
  let h, m;
  if (typeof input === "string" && input.includes(":")) {
    const [hs, ms] = input.split(":");
    h = parseInt(hs, 10);
    m = parseInt(ms, 10) || 0;
  } else {
    const d = new Date(input);
    h = d.getHours();
    m = d.getMinutes();
  }
  if (Number.isNaN(h)) return String(input);
  const ampm = h >= 12 ? "PM" : "AM";
  const hh = h % 12 === 0 ? 12 : h % 12;
  const mm = String(m).padStart(2, "0");
  return `${hh}:${mm} ${ampm}`;
}

export function fmtDateTime12(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "numeric", minute: "2-digit", hour12: true });
}
